// @ts-nocheck
import React, { useCallback } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { ReactComponent as RuleIcon } from '../../../../../assets/Icons/lucideIcons/clipboard-check.svg';

import ConditionalFormattingDrawer from './ConditionalFormattingDrawer';
import GroupWrapper from '../Wrappers/GroupWrapper';
import {
  useTableDispatch,
  useTableState,
} from '../../../context/TableSchemaBuilderContext';

const ConditionalFormattingButton = () => {
  const { ui } = useTableState();
  const dispatch = useTableDispatch();

  const handleOpenConditionalFormattingEditor = useCallback(() => {
    dispatch({
      type: 'SET_OPEN_CONDITIONAL_FORMATTING_DRAWER',
    });
  }, [dispatch]);

  const handleCloseConditionalFormattingEditor = useCallback(() => {
    dispatch({
      type: 'SET_CLOSE_CONDITIONAL_FORMATTING_DRAWER',
    });
  }, [dispatch]);

  return (
    <GroupWrapper label="Conditional Formatting">
      <Tooltip title="Conditional Formatting">
        <IconButton
          size="small"
          onClick={handleOpenConditionalFormattingEditor}
        >
          <RuleIcon width={18} height={18} />
        </IconButton>
      </Tooltip>
      <ConditionalFormattingDrawer
        open={ui?.showConditionalFormattingDrawer}
        onClose={handleCloseConditionalFormattingEditor}
      />
    </GroupWrapper>
  );
};

export default ConditionalFormattingButton;
